window.typeValidation = function(e) {
  // error_div = e.next()
  // if ( error_div.length == 1 ) {
  //   error_div.addClass('d-none')
  //   e.removeClass('is-invalid')
  //   error_div.closest(".input-group").find(".input-group-prepend select").css("border-color", "#d1d3e2");
  // }
}
